import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { IProductVariationSize } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetProductVariationTypes = (filters: string[] = []) => {
  return useQuery({
    queryKey: queryKeys.productVariationTypes.all(filters),
    queryFn: () => fetchProductVariationTypes(filters),
  });
};

const fetchProductVariationTypes = async (
  filters: string[] = [],
): Promise<IProductVariationSize[]> => {
  const url = `/productVariationSizes${generateQuery(
    [],
    concat(filters, 'pageSize=0'),
  )}`;

  const response = await requestCCApi({ url });

  return response.data;
};
